/* shah */
import React from 'react'

const WhiteCurserIcon = () => {
    return (
        <svg id="SmallBoxSVG-cursor" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M1075 5103 c-44 -23 -74 -53 -96 -95 -18 -36 -19 -91 -19 -2028 0
-1656 2 -1996 14 -2023 29 -69 115 -126 191 -127 88 0 98 7 481 345 202 179
371 322 375 318 4 -5 140 -321 301 -704 162 -383 302 -708 311 -723 28 -42 75
-66 133 -66 43 0 101 22 400 151 192 83 360 161 372 173 13 11 31 34 39 50 35
68 32 79 -275 806 l-289 685 496 5 c343 3 504 9 522 17 42 18 89 63 109 104
27 52 27 146 0 199 -27 53 -2827 2891 -2874 2914 -44 21 -151 21 -191 -1z
m1468 -1748 l1134 -1150 -493 -5 c-481 -5 -493 -5 -521 -26 -42 -32 -65 -78
-65 -132 0 -39 51 -168 307 -775 169 -401 305 -730 303 -733 -7 -6 -351 -155
-352 -152 -4 7 -46 105 -323 763 -162 385 -304 714 -314 732 -23 36 -91 73
-135 72 -16 0 -43 -6 -61 -12 -18 -7 -177 -140 -354 -297 -177 -157 -337 -298
-355 -313 l-34 -28 0 1668 0 1668 65 -65 c35 -36 575 -582 1198 -1215z"/>
            </g>
        </svg>
    )
}

export default WhiteCurserIcon